import React from 'react';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import MainLayoutRoutes from "./mainRoutes";
import SignIn from "../container/auth/signIn/signIn";
import verifyPassword from '../container/verifyPassword/verifyPassword/verifyPassword';
import forgotPassword from '../container/forgotPassword/forgotPassword/forgotPassword';
import {Confirmation, HelpModal} from "../components";
// import './animal'
import Dashboard from "../container/homePage";

const Users = React.lazy(() => import('../container/users'));
const CreateUser = React.lazy(() => import('../container/users/createUser/createUser'));
const ChangePassword = React.lazy(() => import('../container/users/changePassword/changePassword'));
const References = React.lazy(() => import('../container/reference'));
const InvoiceReports = React.lazy(() => import('../container/invoices/invoiceReport'));
const CPManagement = React.lazy(() => import('../container/management'));
const CreateCP = React.lazy(() => import('../container/management/createCP/createCP'));
const Services = React.lazy(() => import('../container/management/services'));
const CreateService = React.lazy(() => import('../container/management/services/createService/createService'));
const CreateReference = React.lazy(() => import('../container/reference/createReference/createReference'));
const EditReference = React.lazy(() => import('../container/reference/createReference/createReference'));
const Contract = React.lazy(() => import('../components/contract'));
const CreateContract = React.lazy(() => import('../components/contract/contractForm/contractCp'));
const EditCP = React.lazy(() => import('../container/management/editCP/editCP'));
const LabelServices = React.lazy(() => import('../container/labelServices'));
const CreateLabelService = React.lazy(() => import('../container/labelServices/createLabelServices/createLabelService'));
const Labels = React.lazy(() => import('../container/labels'));
const CreateLabel = React.lazy(() => import('../container/labels/createLabel/createLabel'));
const Contents = React.lazy(() => import('../container/contents'));
const CreateContent = React.lazy(() => import('../container/contents/createContent/createContent'));
const ParentLabels = React.lazy(() => import('../container/parentLabels'));
const CreateParentLabel = React.lazy(() => import('../container/parentLabels/createParentLabel/createParentLabel'));
const UploadReports = React.lazy(() => import('../container/uploadReports'));
const ServiceReport = React.lazy(() => import('../container/reporting/serviceReports'));
const LabelServiceReport = React.lazy(() => import('../container/reporting/labelServiceReports'));
const InvoiceGenerationReport = React.lazy(() => import('../container/invoices/invoiceGeneration'));
const ContentReport = React.lazy(() => import('../container/reporting/contentReport'));
const LicensedLabelService = React.lazy(() => import('../container/labelServices/licensedLabelServices/licensedLabelService'));
const LabelLicensedTerritories = React.lazy(() => import('../container/labelServices/licensedTerritories'));

function Routes() {
  return (
    <Router>
      <Switch>
        <Route path="/" exact component={SignIn}/>
        <Route path="/login" exact component={SignIn}/>
        <Route path="/forgotPassword" exact component={forgotPassword}/>
        <Route path="/verifyPassword" exact component={verifyPassword}/>
        <MainLayoutRoutes exact path="/dashboard" render={matchprops => (<Dashboard {...matchprops} />)}
                          routeName={'dashboard'}/>
        <MainLayoutRoutes exact path="/users" render={matchprops => (<Users {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/users/:id" render={matchprops => (<CreateUser {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/users/createNew" render={matchprops => (<CreateUser {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/changePassword" render={matchprops => (<ChangePassword {...matchprops} />)}/>

        <MainLayoutRoutes exact path="/references" render={matchprops => (<References {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/references/createNew"
                          render={matchprops => (<CreateReference {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/references/manage"
                          render={matchprops => (<EditReference {...matchprops} />)}/>

        <MainLayoutRoutes exact path="/invoice" render={matchprops => (<InvoiceReports {...matchprops} />)}/>


        <MainLayoutRoutes exact path="/cps" render={matchprops => (<CPManagement {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/cps/create-new" render={matchprops => (<CreateCP {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/cps/manage-cps/:id" render={matchprops => (<EditCP {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/cps/services/:id" render={matchprops => (<Services {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/cps/contract/:id" render={matchprops => (<Contract {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/cps/contract-new/:id" render={matchprops => (<CreateContract {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/cps/services/:id/create-service"
                          render={matchprops => (<CreateService {...matchprops} />)}/>


        <MainLayoutRoutes exact path="/parent-label" render={matchprops => (<ParentLabels {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/parent-label/create-new"
                          render={matchprops => (<CreateParentLabel {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/parent-label/labels/:id" render={matchprops => (<Labels {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/parent-label/labels/:id/create-new"
                          render={matchprops => (<CreateLabel {...matchprops} />)}/>

        <MainLayoutRoutes exact path="/labels" render={matchprops => (<Labels {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/labels/create-new" render={matchprops => (<CreateLabel {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/labels/edit" render={matchprops => (<CreateLabel {...matchprops} />)}/>

        <MainLayoutRoutes exact path="/contents" render={matchprops => (<Contents {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/contents/create-new" render={matchprops => (<CreateContent {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/contents/edit" render={matchprops => (<CreateContent {...matchprops} />)}/>

        <MainLayoutRoutes exact path="/labels-service" render={matchprops => (<LabelServices {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/labels-service/create-new"
                          render={matchprops => (<CreateLabelService {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/labels-service/:id"
                          render={matchprops => (<CreateLabelService {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/labels-licensed-territories/licensed-service"
                          render={matchprops => (<LicensedLabelService {...matchprops} />)}/>

        <MainLayoutRoutes exact path="/labels-licensed-territories"
                          render={matchprops => (<LabelLicensedTerritories {...matchprops} />)}/>

        <MainLayoutRoutes exact path="/upload-reports" render={matchprops => (<UploadReports {...matchprops} />)}/>

        <MainLayoutRoutes exact path="/service-report" render={matchprops => (<ServiceReport {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/label-service-report"
                          render={matchprops => (<LabelServiceReport {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/invoice-generation"
                          render={matchprops => (<InvoiceGenerationReport {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/content-report" render={matchprops => (<ContentReport {...matchprops} />)}/>
        {/*<Redirect to={'/'}/>*/}
      </Switch>
      <Confirmation/>
      <HelpModal/>
    </Router>
  )
    ;
}

export default Routes;


// https://www.youtube.com/watch?v=Ll4JtXQ2ag0
// npm i react-otp-input
